<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Billing Overview</el-breadcrumb-item>
      <el-breadcrumb-item>Pause Subscription Overview</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <h2 style="text-align: left;"> Pause Subscription Overview </h2>
    <div class="container">
      Please Select a Date Range <span style="width: 30px;"> </span><date-range-picker @date-change="handleDateChange" /> <span
        style="width: 30px;"> </span>
    </div>
    <el-divider></el-divider>
    <div class="grid">
      <div class="chart" id="chart1">数据等待中</div>
     </div>
    <el-divider></el-divider>
    <h3 style="text-align: left;">详细数据 <el-button type="primary" @click="exportCsv" style="  margin-left: 75%; ">下载
        CSV</el-button></h3>
    <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">

      <el-table-column prop="date" label="日期" width="150" sortable>
      </el-table-column>

      <el-table-column prop="newSubs" label="新增订阅(含试用)"> </el-table-column>

      <el-table-column prop="cancledSubs" label="取消订阅(按行为)"> </el-table-column>

      <el-table-column prop="createPause" label="设置暂停订阅"> </el-table-column>

      <el-table-column prop="pauseSubs" label="暂停订阅开始"> </el-table-column>

      <el-table-column prop="resumeSubs" label="取消暂停"> </el-table-column>

      <el-table-column prop="currentlyPaused" label="暂停中">
  <template slot-scope="scope">
    <div>
  <!-- 判断 currentlyPaused 是否为 0 -->
  <span v-if="scope.row.currentlyPaused === 0">
    {{ scope.row.currentlyPaused }}
  </span>
  <a v-else :href="`/#/subsList?pauseType=currentlyPaused&pauseDateType=between&pauseDateRange=${scope.row.date}to${scope.row.date}`" target="_blank">
    {{ scope.row.currentlyPaused }}
  </a>
</div>
  </template>
</el-table-column>


    </el-table>


  </div>
</template>

<script>

import dateRangePicker from './dateRangePicker.vue';
import { exportToCsv } from '@/utils/exportToCsv';
export default {
  components: {
    dateRangePicker
  },

  data() {
    return {
      tableData: [],
      dateRange: ''
    }
  },
  // 新增watch 观察参数变化,按照dateRange变化,重新getData
  watch: {
    dateRange() {
      this.getData(this.dateRange);
    }
  },

  // 新建methods 区域, 专门定义各个方法和参数的地方
  methods: {
    async getData(dateRange) {

      this.tableData = []

      let res = await this.$http.get("/da/get_subs_pause/" + dateRange)
      this.tableData = res.data
      this.initCharts();
    },

    handleDateChange(date) {
      this.dateRange = date;
      console.log('Selected date range:', this.dateRange);
    },

    exportCsv() {
      let fileName = "Pause Subscription Overview" + "_" + this.dateRange
      exportToCsv(this.tableData, fileName)
    },

    getRateColor(percent) {
      const value = parseFloat(percent) / 100
      if (value > 0.85) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= 0.8 && value < 0.85) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },


   initCharts() {
  const chart = this.$echarts.init(document.getElementById("chart1"));
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      },
      formatter: function (params) {
        let tooltipText = `Date: ${params[0].axisValue}<br/>`;
        params.forEach(param => {
          tooltipText += `${param.seriesName}: ${param.value}<br/>`;
        });
        return tooltipText;
      },
    },
    title: {
      text: "Pause Subscription Overview",
    },
    legend: {
      data: ['Cancelled Subs', 'Created Pause', 'Paused Subs','Currently Paused']
    },
    xAxis: {
      type: 'category',
      data: this.tableData.map(item => item.date),
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        name: 'Cancelled Subs',
        data: this.tableData.map(item => item.cancledSubs),
        type: 'line',
        smooth: false,
        showSymbol: false, // 去掉标记点
      },
      {
        name: 'Created Pause',
        data: this.tableData.map(item => item.createPause),
        type: 'line',
        smooth: false,
        showSymbol: false, // 去掉标记点
      },
      {
        name: 'Paused Subs',
        data: this.tableData.map(item => item.pauseSubs),
        type: 'line',
        smooth: false,
        showSymbol: false, // 去掉标记点
      },
      {
        name: 'Currently Paused',
        data: this.tableData.map(item => item.currentlyPaused),
        type: 'line',
        smooth: false,
        showSymbol: false, // 去掉标记点
      },
    ],
  };
  chart.setOption(option);
}



  },

  mounted: function () {


  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}

.device-number-link a {
  color: blue;
  /* 鼠标悬停时变为蓝色 */
  text-decoration: none;
  /* 移除下划线 */
}

.device-number-link a:hover {
  color: #ffaa00;
  /* 点击时变为海思蓝色 */
}

.device-number-link a:active {
  color: inherit;
  /* 正常状态下使用继承的颜色，即没有特别的颜色 */

}

.grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  gap: 10px;
  width: 95%;

}

.chart {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 5px;
  height: 380px;
}
</style>